import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=383ef9be&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./Resources.vue?vue&type=style&index=0&id=383ef9be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports